import { InjectionToken } from "@angular/core";

// import translations
import { LANG_EN_TRANS } from "./lang-en";
import { LANG_ES_TRANS } from "./lang-es";
import { LANG_XX_TRANS } from "./lang-xx";
import { LANG_PROPER_TRANS } from "./lang-proper";

// translation token
export const TRANSLATIONS = new InjectionToken("translations");

// all traslations
export const dictionary = {
	"en": LANG_EN_TRANS,
	"es": LANG_ES_TRANS,
	"xx": LANG_XX_TRANS,
	"proper": LANG_PROPER_TRANS,
};

// providers
export const TRANSLATION_PROVIDERS = [
	{ provide: TRANSLATIONS, useValue: dictionary },
];
